import { render, staticRenderFns } from "./RefCoChild.vue?vue&type=template&id=021e5419"
import script from "./RefCoChild.vue?vue&type=script&lang=js"
export * from "./RefCoChild.vue?vue&type=script&lang=js"
import style0 from "./RefCoChild.vue?vue&type=style&index=0&id=021e5419&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports